import React from 'react';
import {PageTitle} from '../../common/pageTitle/PageTitle';
import {Helmet} from 'react-helmet';
import './eightOneOnePage.scss';
import {EightOneOneCallout} from "../../common/eightOneOneCallout/eightOneOneCallout";
import stepOne from './assets/811_1_2x.png';
import stepTwo from './assets/811_2_2x.png';
import stepThree from './assets/811_3_2x.png';
import stepFour from './assets/811_4_2x.png';
import stepFive from './assets/811_5_2x.png';
import stepSix from './assets/811_6_2x.png';

/**
 * The FactsAndStatsPage component.
 *
 * @constructor
 */
export class EightOneOnePage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */

  playVideo() {
    /*if(!this.state.videoIsPlaying){
      this.refs.vidRef.play();
      this.setState({'videoIsPlaying':true});
    }
    else{
      this.refs.vidRef.pause();
      this.setState({'videoIsPlaying':false});
    }*/

    this.refs.modalBtn.click();

  }

  stopVideo(){

    var mainVideo = this.refs.mainVideo;
    console.log(mainVideo);
    var vidSrc = mainVideo.getAttribute('src');
    mainVideo.setAttribute('src','');
    mainVideo.setAttribute('src',vidSrc);

  }
  render() {
    return (
      <div id="eightOneOnePage" className="system-page">
        <Helmet>
          <title>811 Info - NEI</title>
          <meta name = "description" content ='811 is the national "Call Before You Dig" phone number to request to have underground lines marked. This call is generally free and required by law.' />
        </Helmet>
        <div className="container-fluid">
          <div className="row">
            <div className="container">
              <div className="row">
                <div className="col">
                  <h1>About 811</h1>
                  <p className="last">811 is the national "Call Before You Dig" phone number (the option also exists to fill out an online form) to request to have underground lines marked by using paint, flags, or stakes. This call is generally free and required by law.</p>
                  <h1 className="last">How 811 Works</h1>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="container callout-container">
               <div className="row">
                 <div className="col pr-0 pl-0">
                   <EightOneOneCallout imgStep={stepOne} text="When someone contacts 811, a representative collects information about the excavation activity and location."  />

                   <EightOneOneCallout imgStep={stepTwo} text="The one call notification center then relays this information to operators of underground facilities near the proposed excavation area." />

                   <EightOneOneCallout imgStep={stepThree} text="Utilities and pipeline companies who are potentially impacted by the proposed excavation will send a locator out to identify and mark the location of their lines near the excavation or confirm their facilities are not impacted, or are 'all clear.'" />

                   <EightOneOneCallout imgStep={stepFour} text="Excavators are required to wait while the marking of the lines occurs. This wait time is prescribed in your state law. Consult your state law, or the Safe Excavator app for information about the required wait time." />

                   <EightOneOneCallout imgStep={stepFive} text="Proceed with care and in accordance with the requirements of your state law."
                                       title="These requirements should include, but are not limited to:"
                                       bulletOne="Confirming the accuracy of the markings by hand digging or vacuum excavating the area to expose the facility"
                                       bulletTwo="Obeying the tolerance zone limitations"
                                       bulletThree="Making additional notification(s) to 811 if certain conditions exist or events occur"
                   />

                   <EightOneOneCallout imgStep={stepSix} text="Report any damage regardless of how minor. If you scratch, dent, scrape, crack, cut or cause damage of any type to a facility, contact the facility operator and 811."
                                       secondParagraph="Any damage to underground facilities (utilities or pipelines) may result in damage that could become worse over time and potentially result in a preventable failure of the facility."
                                       hascgaText={true}
                                       title="If a product release occurs:"
                                       bulletOne="Immediately leave the area on foot"
                                       bulletTwo="Then call 911"
                                       bulletThree="Next call the utility owner or pipeline operator"
                                       bulletFour="Then call 811"
                   />

                   {/*<div className="row info info-bottom">*/}
                     {/*<div className="col-lg-12">*/}
                       {/*<h1>Just because you have called, doesn't mean you're done</h1>*/}
                       {/*<p>*/}
                         {/*Always remember that contacting 811 is only the first step in protecting you and underground facilities. Frequent communication between an excavator and facility operator as well as continued cooperation between all parties is an essential part of the entire process of conducting a safe and successful excavation. Be familiar with the safe excavation requirements in your state prior to beginning any project.*/}
                       {/*</p>*/}

                       {/*<div className="safeDiggingChecklistCtn">*/}
                         {/*<a id="checklistBtn" href="/safe-digging-checklist" onClick={ e => { e.preventDefault(); this.props.history.push('/safe-digging-checklist');} } className="btn btn-warning">Safe Digging Checklist</a>*/}
                       {/*</div>*/}
                     {/*</div>*/}
                   {/*</div>*/}
                 </div>
               </div>
            </div>
          </div>

          <div className="row body-padding-row">
            <div className="container">
              <div className="row">
                <div className="col">
                  <h1>Just because you have called, doesn't mean you're done</h1>
                  <p>
                    Always remember that contacting 811 is only the first step in protecting you and underground facilities. Frequent communication between an excavator and facility operator as well as continued cooperation between all parties is an essential part of the entire process of conducting a safe and successful excavation. Be familiar with the safe excavation requirements in your state prior to beginning any project.
                  </p>

                  <div className="safeDiggingChecklistCtn">
                    <a id="checklistBtn" href="/safe-digging-checklist" onClick={ e => { e.preventDefault(); this.props.history.push('/safe-digging-checklist');} } className="btn btn-warning">Safe Digging Checklist</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row stats-section">
            <div className="container">
              <div className="row">
                <div className="col-12"><h1 className="text-center">What's at stake?</h1></div>
                <div className="col">
                  <ul>
                    <li>Risk of injury, electrocution or death</li>
                    <li>Fire, explosion, etc.</li>
                    <li>Loss of services</li>
                  </ul>
                </div>
                <div className="col">
                  <ul>
                    <li>Product clean up</li>
                    <li>Environmental damage</li>
                    <li>Potential fines and penalties</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>




        </div>


        <div className="modal fade"   id="modal-video" tabIndex="-1" role="dialog" aria-labelledby="modal-video-label" onClick={this.stopVideo.bind(this)}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="modal-video">
                  <div className="embed-responsive embed-responsive-16by9">
                    <iframe  ref="mainVideo" src="https://player.vimeo.com/video/282063891/" width="750px" height="750px" frameBorder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen="true"></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

EightOneOnePage.propTypes = {};

export default EightOneOnePage;



// WEBPACK FOOTER //
// ./src/components/pages/eightOneOne/EightOneOnePage.js